import { render, staticRenderFns } from "./FileExistsModal.vue?vue&type=template&id=4820cbc1&scoped=true"
import script from "./FileExistsModal.vue?vue&type=script&lang=js"
export * from "./FileExistsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820cbc1",
  null
  
)

export default component.exports